import { merge, of, pipe } from 'rxjs';
import { filter as rxFilter, map as rxMap, share, withLatestFrom } from 'rxjs/operators';
import { metaValidationGroups } from '../../../utils/data';
import { enhanceFormDescriptor } from '../../../utils/formDescriptor';
import { runType } from '../../../validations/constants';
import { getFieldsToValidateFromDescriptor, getSectionFieldsToValidate } from '../../../validations/utils';
import validateFields from '../../../validations/validateFields';
import { actionNames, createValidationGroups } from '../../transfer/control';
import { updateValidationResultMultiple } from '../../transfer/transmission';
import { filterByActionType } from '../../utils';
import { validateSyncAndAsyncFields } from '../utils';
const createFormValidationParams = ([action, formData, formDescriptor, formFieldState], reduxStore)=>({
        groups: metaValidationGroups(action),
        runType: runType.FORM,
        expandDependent: false,
        fieldsToValidate: action?.meta?.section ? getSectionFieldsToValidate(formDescriptor, formData, formFieldState, action.meta.section) : getFieldsToValidateFromDescriptor(formDescriptor, formData),
        formData,
        formFieldState,
        formDescriptor,
        reduxStore
    });
const validateMultiple = ({ formData$, formDescriptor$, formFieldState$ }, reduxStore)=>pipe(withLatestFrom(formData$, formDescriptor$, formFieldState$), rxMap((value)=>validateFields(createFormValidationParams(value, reduxStore))));
export const formValidationPromise = (action, formStream$, reduxStore)=>of(action).pipe(validateSyncAndAsyncFields(formStream$, reduxStore, createFormValidationParams)).toPromise();
export const formValidateOnlyData = ({ formDescriptorFn, formData, groups, reduxStore })=>{
    const formDescriptor = enhanceFormDescriptor(formDescriptorFn());
    return validateFields({
        groups: createValidationGroups({
            groups
        }).validationGroups,
        runType: runType.FORM,
        expandDependent: false,
        fieldsToValidate: getFieldsToValidateFromDescriptor(formDescriptor, formData),
        formData,
        formFieldState: undefined,
        formDescriptor,
        reduxStore
    });
};
export default (({ control$, formData$, formDescriptor$, ...other$ }, reduxStore)=>{
    const action$ = merge(control$.pipe(filterByActionType(actionNames.VALIDATE_FORM)), control$.pipe(filterByActionType(actionNames.RESET_FORM), rxFilter(({ meta })=>meta.validate))).pipe(validateMultiple({
        formData$,
        formDescriptor$,
        ...other$
    }, reduxStore), rxMap((payload)=>updateValidationResultMultiple(payload)), share());
    return merge(action$);
});
